import { type TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type AirportTaxiResolvedPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      mainPath: string;
      bookingsPath: string;
    };

export function resolveAirportTaxiApiPaths(transportContext: TransportAirlineApiContext): AirportTaxiResolvedPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }
  if (transportContext.mode === "airline") {
    const base = `v1/airports/${encodeURIComponent(transportContext.iataCode)}/transports/airport-taxi`;
    return {
      kind: "ok",
      mainPath: base,
      bookingsPath: `v1/airports/${encodeURIComponent(transportContext.iataCode)}/bookings`
    };
  }
  return {
    kind: "ok",
    mainPath: "transport/v1/airport-taxi",
    bookingsPath: "bookings"
  };
}
